export default "__VITE_ASSET__096c5f85__"